import { Transaction } from '../services/types';
import { AnalyticsBasePayload } from './events';
import { paymentMethodFromLink, resolveTemplateName } from '../templates/templateNames';

/**
 * The template dimension comes from the same resolution the renderer uses (`resolveTemplateName`),
 * not from a duplicated merchant list — a list of its own drifts and reports a screen nobody saw.
 *
 * Consequence for analysis: `template` values in new data do not line up with historical slices.
 */
export const detectTemplate = (
  merchant: string | null | undefined,
  paymentMethod?: string | null,
): AnalyticsBasePayload['template'] => resolveTemplateName(merchant ?? undefined, paymentMethod);

export const buildBasePayload = (
  uuid: string | undefined,
  transaction: Transaction | null | undefined,
): AnalyticsBasePayload => ({
  uuid,
  merchant: transaction?.merchant ?? null,
  paymentMethod: transaction?.paymentMethod ?? null,
  template: detectTemplate(transaction?.merchant, transaction?.paymentMethod ?? paymentMethodFromLink()),
});
